//Splash.tsx =================================================
import "./Util/Prototypes";

import * as MainMenu from "./Menus/MainMenu";
import * as Settings from "./Settings";

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { blueGrey, red } from '@mui/material/colors';

import React from "react";

let visible: boolean = true;

interface iProps {
}

//Render function.
export function Render(props: iProps) {

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did mount.
   React.useEffect(() => {
   }, []);

   function handleAgree() {
      //console.error("Handle Agree");
      visible = false;
      refresh();
      setTimeout(function () { MainMenu.render(); }, 600); //Focus name search box.
   }

   function handleDisagree() {
      window.history.back();
   }

   function handleClose(event, reason) {
   //   console.error("Handle Close: reason: " + reason);
   //   if (reason === "backdropClick") {
      return;
   //   }
   }

   //Render components. Custom! <DialogContentText id="alert-dialog-description" style={{ color: 'red' }}>
   return (
      <Dialog
         disableEscapeKeyDown
         open={visible}
         onClose={handleClose}
         aria-labelledby="alert-dialog-title"
         aria-describedby="alert-dialog-description"
         scroll="paper"
      >
         <DialogTitle id="alert-dialog-title" style={{ paddingBottom: 0, paddingTop: 9, color: '#333333' }} >
            Welcome to the City of Poway GIS Mapping Application
         </DialogTitle>
         <DialogContent tabIndex={0}>
            <DialogContentText id="alert-dialog-description" style={{ color: blueGrey[900] }}>
               This application allows you to search and view property information as well as many other map and data types. Need help getting started? Check out our <a href="./Help/home.html" target="_blank">Quick Help page</a>.
               <br /><br />
               <b>Disclaimer:</b> This site provides a visual display of data for your convenience.
               Every reasonable effort has been made to assure the accuracy of the maps, images and associated data.
               This information is for reference purposes only and should be used as a guide to finding out planning and other related information.
               The City of Poway makes no warranty, representation or guarantee as to the content, sequence, accuracy,
               timeliness or completeness of any of the data provided herein. Do not make any business decisions based on this data before validating
               your decision with the City of Poway Development Services Department.
            </DialogContentText>

            <div className="app-flex-row-center" style={{ marginTop: 3 }}>
               <img height={43} src={Settings.webSiteLogo} alt="logo" />
            </div>
         </DialogContent>

         <DialogActions>
            <Button onClick={handleDisagree} color="info">
               Disagree
            </Button>
            <Button onClick={handleAgree} color="info" autoFocus>
               Agree
            </Button>
         </DialogActions>
      </Dialog>
   ); //end return.

} //end function.
